import _get from "lodash/get";
import { MessageType } from '@bowtie-web/common/lib/notification';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Close from '@mui/icons-material/Close';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { keyframes } from '@mui/material/styles';
import * as React from 'react';
import { BOWTIE_PINK, GREEN_DAY, YELLOW_SUBMARINE, HOTEL_CALIFORNIA, WHITE } from '../palette';
import { Error } from '../svg/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const iconMapping = {
  [MessageType.INFO]: InfoOutlined,
  [MessageType.ERROR]: Error,
  [MessageType.WARNING]: Error,
  [MessageType.SUCCESS]: CheckCircleOutlined
};
const accents = {
  [MessageType.INFO]: {
    border: 'transparent'
  },
  [MessageType.ERROR]: {
    border: HOTEL_CALIFORNIA,
    icon: HOTEL_CALIFORNIA,
    message: HOTEL_CALIFORNIA
  },
  [MessageType.WARNING]: {
    border: YELLOW_SUBMARINE,
    icon: YELLOW_SUBMARINE
  },
  [MessageType.SUCCESS]: {
    border: GREEN_DAY,
    icon: GREEN_DAY,
    message: GREEN_DAY
  }
};
const progress = keyframes({
  from: {
    width: '100%'
  },
  to: {
    width: '0%'
  }
});
const Toast = props => {
  const {
    children,
    onClose,
    variant = MessageType.INFO,
    timeout,
    disableElevation = false,
    disableProgress = false
  } = props;
  const Icon = React.useMemo(() => iconMapping[variant], [variant]);
  const accent = accents[variant];
  const childrenArr = React.Children.toArray(children);
  return _jsxs(Box, {
    sx: {
      position: 'relative'
    },
    children: [_jsxs(Box, {
      sx: {
        display: 'flex',
        p: 2,
        flexWrap: 'nowrap',
        boxShadow: disableElevation ? 'none' : '-1px 2px 11px 0 rgba(167, 167, 167, 0.5)',
        borderTop: 'solid 4px',
        borderColor: accent.border,
        backgroundColor: WHITE
      },
      children: [_jsxs(Box, {
        sx: {
          display: 'grid',
          gap: 2,
          flexGrow: 1,
          alignItems: 'center',
          wordBreak: 'break-word',
          overflow: 'auto',
          color: 'inherit',
          py: 1,
          px: 0
        },
        children: [_jsxs(Box, {
          sx: {
            display: 'flex',
            flexWrap: 'nowrap'
          },
          children: [_jsx(Icon, {
            htmlColor: accent.icon
          }), _jsx(Box, {
            sx: {
              ml: 1.5,
              lineHeight: '24px',
              color: accent.message
            },
            children: childrenArr[0]
          })]
        }), childrenArr.slice(1).map((child, index) => _jsxs(React.Fragment, {
          children: [_jsx(Divider, {}), child]
        }, _get(child, 'key', index)))]
      }), onClose && _jsx(Box, {
        sx: {
          mr: -1,
          pl: 1
        },
        children: _jsx(IconButton, {
          "aria-label": "close",
          onClick: onClose,
          size: "large",
          children: _jsx(Close, {
            sx: {
              fontSize: 16
            }
          })
        })
      })]
    }), timeout && timeout > 0 && !disableProgress ? _jsx(Box, {
      sx: {
        position: 'absolute',
        bottom: 0,
        height: 2,
        width: 0,
        backgroundColor: BOWTIE_PINK,
        animation: `${progress} linear 1`
      },
      style: {
        animationDuration: `${timeout}ms`
      }
    }) : null]
  });
};
export default Toast;